import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IBankBillet from "Types/BankBillet";
import IDas from "Types/Das";
import _ from "lodash";
import ResultModel from "models/ResultModel";

export const GET_DASES = "[DAS] GET_DASES";
export const GET_DASES_SUCCESS = "[DAS] GET_DASES_SUCCESS";
export const GET_DASES_FAILED = "[DAS] GET_DASES_FAILED";

export const GENERATE_DASES = "[DAS] GENERATE_DASES";
export const GENERATE_DASES_SUCCESS = "[DAS] GENERATE_DASES_SUCCESS";
export const GENERATE_DASES_FAILED = "[DAS] GENERATE_DASES_FAILED";

export const SEND_DASES = "[DAS] SEND_DASES";
export const SEND_DASES_SUCCESS = "[DAS] SEND_DASES_SUCCESS";
export const SEND_DASES_FAILED = "[DAS] SEND_DASES_FAILED";

export const REFRESH_DAS = "[DAS] REFRESH_DAS";
export const REFRESH_DAS_SUCCESS = "[DAS] REFRESH_DAS_SUCCESS";
export const REFRESH_DAS_FAILED = "[DAS] REFRESH_DAS_FAILED";

export const SET_VALUE = "[DAS] SET_VALUE";
export const CLEAR_VALUES = "[DAS] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function generateDases(data: any[], callback?: Callback<any[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GENERATE_DASES });

		try {
			const { login } = getState();

			const chunks = _.chunk(data, 100);

			let response: Response | any = null;

			const models: any[] = [];

			for (const chunk of chunks) {
				response = await api.sendPost("/Das/Schedule/Generate", chunk, {
					Authorization: `Bearer ${login.token}`
				});

				const result: ResultModel<any[]> = await response.json();

				models.push(...(result.model || []));
			}

			dispatch({
				type: GENERATE_DASES_SUCCESS,
				payload: models
			});

			callback && callback(null, models);
		} catch (error) {
			return dispatch({
				type: GENERATE_DASES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function sendDases(data: any[], callback?: Callback<IDas[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: SEND_DASES });

		try {
			const { login } = getState();

			const chunks = _.chunk(data, 100);

			let response: Response | any = null;

			const models: any[] = [];

			for (const chunk of chunks) {
				response = await api.sendPost("/Das/Schedule/Send", chunk, {
					Authorization: `Bearer ${login.token}`
				});

				const result: ResultModel<any[]> = await response.json();

				models.push(...(result.model || []));
			}

			dispatch({
				type: SEND_DASES_SUCCESS,
				payload: models
			});

			callback && callback(null, models);
		} catch (error) {
			return dispatch({
				type: SEND_DASES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function send(
	id: string | string[],
	sendEmail: boolean,
	sendWhatsApp: boolean,
	callback?: Callback<any>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: SEND_DASES });

		try {
			const { login } = getState();

			let response: Response;
			if (Array.isArray(id)) {
				response = await api.sendPost(
					`/Das/Send`,
					{ id, sendEmail, sendWhatsApp },
					{
						Authorization: `Bearer ${login.token}`
					}
				);
			} else {
				response = await api.sendPost(
					`/Das/${id}/Send`,
					{
						sendEmail,
						sendWhatsApp
					},
					{
						Authorization: `Bearer ${login.token}`
					}
				);
			}

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: SEND_DASES_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: SEND_DASES_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: SEND_DASES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function refreshDas(id: string, callback?: Callback<any>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: REFRESH_DAS });

		try {
			const { login } = getState();

			const response = await api.sendPost(
				`/Das/${id}/refresh`,
				{},
				{ Authorization: `Bearer ${login.token}` }
			);

			const result = await response.json();

			if (result.isValid) {
				dispatch({ type: REFRESH_DAS_SUCCESS, payload: result.model });
				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);
				dispatch({ type: REFRESH_DAS_FAILED, payload: errors });
				callback && callback(errors);
			}
		} catch (error) {
			dispatch({
				type: REFRESH_DAS_FAILED,
				payload: { error: "Connection error" }
			});
			callback && callback({ error: "Connection error" });
		}
	};
}

export function getDases(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IBankBillet[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_DASES });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Das?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_DASES_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_DASES_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_DASES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
